/**
 * @generated SignedSource<<9d273b673458890dabe6d701208ea1de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RequestWizardStepContainerNode$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AddPlayersPrivateStepNode" | "AddPlayersStepNode" | "PreviousBookingsStep_TimeSlot" | "RequestBookingDetailsStepNode">;
  readonly " $fragmentType": "RequestWizardStepContainerNode";
};
export type RequestWizardStepContainerNode$key = {
  readonly " $data"?: RequestWizardStepContainerNode$data;
  readonly " $fragmentSpreads": FragmentRefs<"RequestWizardStepContainerNode">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RequestWizardStepContainerNode",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RequestBookingDetailsStepNode"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AddPlayersStepNode"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AddPlayersPrivateStepNode"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PreviousBookingsStep_TimeSlot"
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};

(node as any).hash = "484c012886c133314dc724c20bc4a3b3";

export default node;
